import React, { useCallback, useState } from 'react';
import DocumentViewContext from './DocumentView.context';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import useCallbackRef from 'hooks/useCallbackRef';
import { OverlayRef } from 'ncoded-component-library/build/components/atoms/Overlay/Overlay.component';
import DataroomNodeViewModal from 'components/DataroomNodeViewModal';
import { getIsNodeFile } from 'utils';

const DocumentView: React.FC = (props) => {
  const { children } = props;

  const [node, setNode] = useState<DataRoomNode>();
  const [dataRoomName, setDataRoomName] = useState<string>();

  const [previewModal, previewModalRef] = useCallbackRef<OverlayRef>();

  const openNode = useCallback(
    (node: DataRoomNode, dataRoomName?: string) => {
      if (getIsNodeFile(node)) {
        setNode(node);

        if (dataRoomName) setDataRoomName(dataRoomName);

        previewModal?.open();
      }
    },
    [previewModal],
  );

  return (
    <DocumentViewContext.Provider value={{ openNode }}>
      <DataroomNodeViewModal
        ref={previewModalRef}
        node={node}
        dataRoomName={dataRoomName}
      />
      {children}
    </DocumentViewContext.Provider>
  );
};

export default DocumentView;
